import { useState } from "react";

const { REACT_APP_API } = process.env;

const updateUserPreferences = async ({
  preferences,
  accessToken,
  setConfig,
}) => {
  setConfig((prev) => ({ ...prev, isLoading: true }));

  try {
    const response = await fetch(`${REACT_APP_API}/user/prefrences`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(preferences),
    });

    setConfig((prev) => ({ ...prev, success: response.ok }));
  } catch (error) {
    console.error(error);
    setConfig((prev) => ({ ...prev, success: false }));
  }

  setConfig((prev) => ({ ...prev, isLoading: false }));
};

export const useUpdateUserPreferences = () => {
  const [config, setConfig] = useState({
    isLoading: false,
    success: undefined,
  });

  const updatePreferences = (preferences) => {
    const freshTokens = JSON.parse(localStorage.getItem("authTokens"));
    updateUserPreferences({
      preferences,
      accessToken: freshTokens?.access_token,
      setConfig,
    });
  };

  return [config, updatePreferences];
};
